module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen2-40656fe68369ec4f349114e53e78df27.png";